import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UserClientComponent } from './components/user-client.component';
import { PermissionsComponent } from './components/permissions/permissions.component';

const routes: Routes = [
  {
    path:'',
    redirectTo:'liste',
    pathMatch:'full'
  },
  {path:'liste',
  component:UserClientComponent
},
  {path:'permissions',
  component:PermissionsComponent
}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserClientRoutingModule { }
